var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 400,
    viewBox: "0 0 132 395",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 360.22L59.25 376.52",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.24 360.22L59.25 376.52",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 376.52V389.97",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 343.92L114.24 360.22V371.67",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 304.29L59.25 320.59",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.24 304.29L59.25 320.59",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 320.59V343.92",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 287.99L4.25 304.29V317.74L59.25 334.04",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 287.99L114.24 304.29V317.74L59.25 334.04",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 248.37L59.25 264.66",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.24 248.37L59.25 264.66",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 264.66V287.99",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 232.07L4.25 248.37V261.82L59.25 278.12",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 232.07L114.24 248.37V261.82L59.25 278.12",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 192.44L59.25 208.74",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.24 192.44L59.25 208.74",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 208.74V232.07",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 176.14L4.25 192.44V205.89L59.25 222.19",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 176.14L114.24 192.44V205.89L59.25 222.19",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 136.51L59.25 152.81",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.24 136.51L59.25 152.81",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 152.81V176.14",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 120.21L4.25 136.51V149.96L59.25 166.26",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 120.21L114.24 136.51V149.96L59.25 166.26",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 80.58L59.25 96.88",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.24 80.58L59.25 96.88",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 96.88V120.21",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 64.29L4.25 80.58V94.04L59.25 110.33",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 64.29L114.24 80.58V94.04L59.25 110.33",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25 24.66L59.25 40.96",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.44 20.69L59.25 40.96",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 40.96V64.29",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 54.41L114.24 38.11V24.66",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.24 38.11V373.77",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 343.92L4.25 360.22V373.67L59.25 389.97L127.44 369.77V20.69L72.57 4.42999L4.25 24.66V38.11L59.25 54.41",
    stroke: "#3170CE",
    strokeWidth: 8.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131.69,
    height: 394.4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolka);
export default __webpack_public_path__ + "static/media/polka.18d4c1ba104cb720aae2d246f7716396.svg";
export { ForwardRef as ReactComponent };